var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as secp from "@noble/secp256k1";
import { keccak256 } from "js-sha3";
import { randomBytes } from "../crypto";
import { bytesToHex } from "../utils";
import { createNodeId } from "./create";
export function hash(input) {
    return new Uint8Array(keccak256.arrayBuffer(input));
}
export function createPrivateKey() {
    return randomBytes(32);
}
export function publicKey(privKey) {
    return secp.getPublicKey(privKey, true);
}
export function compressPublicKey(publicKey) {
    const point = secp.Point.fromHex(bytesToHex(publicKey));
    return point.toRawBytes(true);
}
export function sign(privKey, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        return secp.sign(hash(msg), privKey, {
            der: false,
        });
    });
}
export function verify(pubKey, msg, sig) {
    try {
        const _sig = secp.Signature.fromCompact(sig.slice(0, 64));
        return secp.verify(_sig, hash(msg), pubKey);
    }
    catch (_a) {
        return false;
    }
}
export function nodeId(pubKey) {
    const publicKey = secp.Point.fromHex(pubKey);
    const uncompressedPubkey = publicKey.toRawBytes(false);
    return createNodeId(hash(uncompressedPubkey.slice(1)));
}
export class ENRKeyPair {
    constructor(nodeId, privateKey, publicKey) {
        this.nodeId = nodeId;
        this.privateKey = privateKey;
        this.publicKey = publicKey;
    }
    static create(privateKey) {
        if (privateKey) {
            if (!secp.utils.isValidPrivateKey(privateKey)) {
                throw new Error("Invalid private key");
            }
        }
        const _privateKey = privateKey || createPrivateKey();
        const _publicKey = publicKey(_privateKey);
        const _nodeId = nodeId(_publicKey);
        return new ENRKeyPair(_nodeId, _privateKey, _publicKey);
    }
    sign(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return sign(this.privateKey, msg);
        });
    }
    verify(msg, sig) {
        return verify(this.publicKey, msg, sig);
    }
}
//# sourceMappingURL=v4.js.map